import { BiasType } from 'libs/end-to-end/src/bias-type';
import { DemographicCategory } from 'libs/end-to-end/src/demographic';
import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { guardExhaustive } from 'libs/end-to-end/src/generic';
import { Phrases } from 'libs/end-to-end/src/phrases';
import { TreatmentRecommendation } from 'libs/end-to-end/src/treatment';
import { TreatmentType } from 'libs/end-to-end/src/treatment';
import { TreatmentTypeNativeEnum } from 'libs/end-to-end/src/treatment';

export interface Point {
  x: number;
  y: number;
}

export const BIAS_TYPE_MESSAGE_IDS: Record<
  BiasType,
  'biasTypeStructural' | 'biasTypePreference' | 'biasTypeInformation'
> = {
  Structural: 'biasTypeStructural',
  Preference: 'biasTypePreference',
  Information: 'biasTypeInformation',
};

export const DEMOGRAPHIC_CATEGORY_MESSAGE_IDS: Record<
  DemographicCategory,
  'disparityTypeRace' | 'disparityTypeGender' | 'disparityTypeDisability'
> = {
  Race: 'disparityTypeRace',
  Gender: 'disparityTypeGender',
  Disability: 'disparityTypeDisability',
};

export const TREATMENT_MESSAGE_IDS: Record<
  TreatmentType,
  | 'treatmentDiversityCopilot'
  | 'treatmentManagerBestPractices'
  | 'treatmentIntelligentSourcingStrategy'
  | 'treatmentTrainingStrategyEmpathySkills'
  | 'treatmentManagerUpskilling'
  | 'treatmentTrainingStrategyCounterStereotype'
  | 'treatmentTrainingStrategyStructuralInequality'
  | 'treatmentSuccessPhenotype'
  | 'treatmentProvideMoreData'
  | 'treatmentCompensationCopilot'
  | 'treatmentHiringCopilot'
  | 'treatmentPromotionCopilot'
  | 'treatmentSourcingCopilot'
  | 'treatmentHiringProcessOptimization'
  | 'treatmentPerformanceProcessOptimization'
  | 'treatmentPromotionProcessOptimization'
  | 'treatmentInterGroupContact'
  | 'treatmentInterGroupContactTraining'
  | 'treatmentBestPracticesAlgorithm'
> = {
  [TreatmentTypeNativeEnum.DiversityCopilot]: 'treatmentDiversityCopilot',
  [TreatmentTypeNativeEnum.ManagerBestPractices]:
    'treatmentManagerBestPractices',
  [TreatmentTypeNativeEnum.IntelligentSourcingStrategy]:
    'treatmentIntelligentSourcingStrategy',
  [TreatmentTypeNativeEnum.TrainingStrategyEmpathySkills]:
    'treatmentTrainingStrategyEmpathySkills',
  [TreatmentTypeNativeEnum.ManagerUpskilling]: 'treatmentManagerUpskilling',
  [TreatmentTypeNativeEnum.TrainingStrategyCounterStereotype]:
    'treatmentTrainingStrategyCounterStereotype',
  [TreatmentTypeNativeEnum.TrainingStrategyStructuralInequality]:
    'treatmentTrainingStrategyStructuralInequality',
  [TreatmentTypeNativeEnum.SuccessPhenotype]: 'treatmentSuccessPhenotype',
  [TreatmentTypeNativeEnum.ProvideMoreData]: 'treatmentProvideMoreData',
  [TreatmentTypeNativeEnum.CompensationCopilot]: 'treatmentCompensationCopilot',
  [TreatmentTypeNativeEnum.HiringCopilot]: 'treatmentHiringCopilot',
  [TreatmentTypeNativeEnum.PromotionCopilot]: 'treatmentPromotionCopilot',
  [TreatmentTypeNativeEnum.SourcingCopilot]: 'treatmentSourcingCopilot',
  [TreatmentTypeNativeEnum.HiringProcessOptimization]:
    'treatmentHiringProcessOptimization',
  [TreatmentTypeNativeEnum.PerformanceProcessOptimization]:
    'treatmentPerformanceProcessOptimization',
  [TreatmentTypeNativeEnum.PromotionProcessOptimization]:
    'treatmentPromotionProcessOptimization',
  [TreatmentTypeNativeEnum.deprecated_InterGroupContactTraining]:
    'treatmentInterGroupContactTraining',
  [TreatmentTypeNativeEnum.deprecated_InterGroupContact]:
    'treatmentInterGroupContact',
  [TreatmentTypeNativeEnum.deprecated_BestPracticesMakingAlgorithms]:
    'treatmentBestPracticesAlgorithm',
};

export interface TreatmentRecommendationUIDetails {
  messageId:
    | 'treatmentBiggestImpact'
    | 'treatmentQuickestWin'
    | 'treatmentMostPopular';
  bgColor: string;
  sortIndex: number;
}

export const TREATMENT_RECOMMENDATIONS: Record<
  TreatmentRecommendation,
  TreatmentRecommendationUIDetails
> = {
  BiggestImpact: {
    messageId: 'treatmentBiggestImpact',
    bgColor: 'bg-tertiary',
    sortIndex: 0,
  },
  QuickestWin: {
    messageId: 'treatmentQuickestWin',
    bgColor: 'bg-blue-600',
    sortIndex: 1,
  },
  MostPopular: {
    messageId: 'treatmentMostPopular',
    bgColor: 'bg-raspberry-600',
    sortIndex: 2,
  },
};
